import { IInvoice, IReinstateablePolicy, IUserAccount } from "config";
import { AppError } from "config/errors";
import { createReinstatementInvoiceMutation } from "gql/mutations/invoice";
import {
  fetchCurrentUserInvoices,
  fetchCurrentUserLatestPayableInvoice,
} from "gql/queries/invoice";
import { getActiveAccount } from "utils/account";

import { createAsyncThunk } from "@reduxjs/toolkit";

/* ------------       THUNKS      ------------------ */

export const createReinstatementInvoice = createAsyncThunk(
  "offerings/createReinstatementInvoice",
  async (policyId: IReinstateablePolicy["id"], { rejectWithValue }) => {
    try {
      const { data } = await createReinstatementInvoiceMutation(policyId);

      return { success: data.createReinstatementInvoice.response.success };
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);

export const getCurrentUserLatestPayableInvoice = createAsyncThunk(
  "invoice/getCurrentUserInvoice",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchCurrentUserLatestPayableInvoice();
      const account = getActiveAccount(data.me);

      return account?.latestPayableInvoice;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);

interface IUserPastDueInvoicesMeta extends IUserAccount {
  invoicesProcessingAmount: number;
  invoicesPastDueBalance: number;
  pastDueInvoices: IInvoice[];
  processingInvoices: IInvoice[];
}

export const getCurrentUserPastDueInvoices = createAsyncThunk(
  "invoice/getCurrentUserPastDueInvoices",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchCurrentUserInvoices();
      const account = getActiveAccount(data.me) as IUserPastDueInvoicesMeta;

      return {
        activePolicy: account?.activePolicy,
        invoicesProcessingAmount: account?.invoicesProcessingAmount,
        invoicesPastDueBalance: account?.invoicesPastDueBalance,
        pastDueInvoices: account?.pastDueInvoices || [],
        processingInvoices: account?.processingInvoices || [],
      };
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
